<div class="page-footer-section bg-dark fg-white">
    <app-footer2-sitemap></app-footer2-sitemap>
    
    <hr>
    <!-- Please don't remove or modify the credits below -->
    <p class="text-center mt-4 wow fadeIn">Copyright &copy; 2021 <a href="#" class="fg-white fw-medium">MindMilieu OPC Private Limited</a>. All right reserved</p>
  </div>